import type { ProductOfferFragment } from '@/services/graphql/generated'
import { getSortedOffers } from '@/utils/offers.utils'

export type ComparableProductOffer = Pick<ProductOfferFragment, 'deductible' | 'insuranceAmount'> & {
  variant: Pick<ProductOfferFragment['variant'], 'typeOfContract'>
}

export const compareOffer = (a: ComparableProductOffer, b: ComparableProductOffer) => {
  if (a.variant.typeOfContract !== b.variant.typeOfContract) return false
  if (JSON.stringify(a.deductible ?? null) !== JSON.stringify(b.deductible ?? null)) return false
  if (JSON.stringify(a.insuranceAmount ?? null) !== JSON.stringify(b.insuranceAmount ?? null)) return false
  return true
}

type SelectOfferInput = {
  offers: Array<ProductOfferFragment>
  selectedOfferId?: string | null
  offerToEdit?: ComparableProductOffer | null
  defaultOfferId?: string | null
}

export const selectOffer = ({
  offers,
  selectedOfferId,
  offerToEdit,
  defaultOfferId,
}: SelectOfferInput): ProductOfferFragment | null => {
  if (offers.length === 0) return null

  if (selectedOfferId) {
    const matchingOffer = offers.find((item) => item.id === selectedOfferId)
    if (matchingOffer) return matchingOffer
  }

  if (offerToEdit) {
    const matchingOffer = offers.find((item) => compareOffer(item, offerToEdit))
    if (matchingOffer) return matchingOffer
  }

  const priceMatchedOffer = offers.find((item) => item.priceMatch != null)
  if (priceMatchedOffer) return priceMatchedOffer

  const defaultOffer = offers.find((offer) => offer.id === defaultOfferId)
  if (defaultOffer) return defaultOffer

  return getSortedOffers(offers)[0]
}
